import styled from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";

export const StyledTable = styled.table`
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    border: ${(props) =>
        props.showTableBorder ? `1px solid ${COLOR_VALUES.Gray_6}` : `none`};
`;

export const StyledLoaderTr = styled.tr`
    position: absolute;
    bottom: 0;
    height: 2px;
    width: 50%;
    background-color: ${COLOR_VALUES.Gray_4};
    animation: loading 3s linear infinite;

    @keyframes loading {
        to {
            transform: translateX(93%);
        }
    }
`;
